import { useCallback } from "react";

import type { PositionsWidgetRow } from "./PositionsWidget.types";
import { POSITIONS_UNAVAILABLE_VALUE } from "./PositionsWidget.utils";

export interface RollPositionDialogProps {
  row: PositionsWidgetRow | null;
  onOpenChange: (open: boolean) => void;
  onConfirmRoll: () => void;
}

export interface RollPositionDialogController {
  open: boolean;
  contractLabel: string;
  quantity: string;
  currentPrice: string;
  onOpenChange: (open: boolean) => void;
  onConfirmRoll: () => void;
}

export const formatRollContract = (row: PositionsWidgetRow): string => {
  if (
    row.compactContract &&
    row.compactContract !== POSITIONS_UNAVAILABLE_VALUE
  ) {
    const underlying =
      row.underlyingSymbol &&
      row.underlyingSymbol !== POSITIONS_UNAVAILABLE_VALUE
        ? row.underlyingSymbol
        : row.symbol;
    return `${underlying} ${row.compactContract}`;
  }
  return row.symbol;
};

export const useRollPositionDialogController = ({
  row,
  onOpenChange,
  onConfirmRoll,
}: RollPositionDialogProps): RollPositionDialogController => {
  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onOpenChange(false);
      }
    },
    [onOpenChange],
  );

  return {
    open: row !== null,
    contractLabel: row ? formatRollContract(row) : "",
    quantity: row?.quantity ?? "",
    currentPrice: row?.currentPrice ?? "",
    onOpenChange: handleOpenChange,
    onConfirmRoll,
  };
};
